import { render, staticRenderFns } from "./SetSearchField.vue?vue&type=template&id=39247480&scoped=true"
import script from "./SetSearchField.vue?vue&type=script&lang=js"
export * from "./SetSearchField.vue?vue&type=script&lang=js"
import style0 from "./SetSearchField.vue?vue&type=style&index=0&id=39247480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39247480",
  null
  
)

export default component.exports